<template>
  <div id="ContainerMedicationInbox">
    <div class="row">
            <div class="col-12">
                  <MdTitle v-bind:Text="$t('Shared.MedicationInbox')" /> 
                    <div class="row">
                                      
                        <div class="col-sm-12 col-md-12 mb-4">
                            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                                <div class="input-group" dir="ltr">
                                    <input type="text" class="form-control" :dir="dirInput" v-model="parameter.SearchCriteria" @keyup.enter="getMedicationInboxList()">
                                        <div class="input-group-append">
                                            <MdButton 
                                                v-bind:Name="'btnsearchinput'"
                                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                                v-bind:IconClass="'mdi mdi-magnify'"
                                                v-on:click="getMedicationInboxList">
                                            </MdButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
            </div> 
     </div>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <b-col md="3" lg="3" sm="12">
            <!--<MdEdit 
                v-bind:Label="$t('Shared.datefrom')"
                v-bind:TypeProp="'date'" 
                v-bind:Name="'DateFrom'"
                v-model="DateFrom"
                v-bind:Min="'1900-01-01'"
                v-bind:Max="'2200-12-31'"
                v-on:change="DateFromChange($event)"
                v-bind:OnPressEnter="getMedicationInboxList">                                     
            </MdEdit>-->
            <MdDateTime 
              :Label="$t('Shared.datefrom')" 
              :Model="DateFrom"                           
              @input="DateFrom = $event"                            
              :Id="'MedicationInboxListDateFrom'"
              :Type="'date'"                  
              :isRequired="false" 
              :Change="DateFromChange" 
              :OnPressEnter="getMedicationInboxList"                         
              :isConfirm="false"
              :ReadOnly="false">
            </MdDateTime>
          </b-col>
          <b-col md="3" lg="3" sm="12">
            <!--<MdEdit 
                v-bind:Label="$t('Shared.dateTo')"
                v-bind:TypeProp="'date'" 
                v-bind:Name="'DateTo'"
                v-model="DateTo"
                v-bind:Min="'1900-01-01'"
                v-bind:Max="'2200-12-31'"
                v-on:change="DateToChange($event)"
                v-bind:OnPressEnter="getMedicationInboxList" >                                     
            </MdEdit>-->
            <MdDateTime 
              :Label="$t('Shared.dateTo')" 
              :Model="DateTo"                           
              @input="DateTo = $event"                            
              :Id="'MedicationInboxListDateTo'"
              :Type="'date'"                  
              :isRequired="false" 
              :Change="DateToChange" 
              :OnPressEnter="getMedicationInboxList"                         
              :isConfirm="false"
              :ReadOnly="false">
            </MdDateTime>
          </b-col>
          <b-col md="3" lg="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Shared.Status')"
              v-bind:Options="StatusList"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'value'"
              v-bind:Model="ModelStatus"
              v-bind:Multiple="false"              
              :Input="ChangeDropDownStatus"/>
          </b-col>
          <b-col md="3" lg="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Medication.RxStatus')"
              v-bind:Options="RxStatusList"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'value'"
              v-bind:Model="ModelRxStatus"
              v-bind:Multiple="false"              
              :Input="ChangeDropDownRxStatus"/>
          </b-col>          
        </div>
        <div class="row">
          <b-col lg="3" md="3" sm="12">
              <MdSelect
                v-bind:Label="$t('Shared.ProgramType')"
                v-bind:Options="this.OptionTypes"
                v-bind:ModelArray="TypeVModel"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'value'"
                v-bind:Placeholder="selectPlaceholder"
                :Input="ChangeDropDownType"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
                v-bind:Label="$tc('Shared.Program')"
                v-bind:Options="ProgramList"
                v-bind:Model="ProgramVmodel"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'code'"
                v-bind:Placeholder="selectPlaceholder"
                v-bind:Multiple="false"
                :Input="ChangeDropDownPrograms"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
                v-bind:Label="$tc('Shared.Patient')"
                v-bind:Options="PatientList"
                v-bind:Model="Patients"
                v-bind:FieldDescription="'patientname'"
                v-bind:FieldCode="'patientcode'"
                v-bind:Multiple="false"                       
                :Input="ChangeDropDownPatients"/>                  
          </b-col>
          <b-col md="3" lg="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Shared.Prescriber')"
              v-bind:Options="PrescriberList"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:Model="ModelPrescriber"    
              v-bind:Multiple="false"                              
              :Input="ChangeDropDownPrescriber"/>
          </b-col> 
        </div>
        <div class="row">
          <b-col lg="3" md="3" sm="12">
            <MdSelect
                v-bind:Label="$t('Shared.Building')"
                v-bind:Options="BuildingList"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'code'"
                v-bind:Model="buildings"   
                v-bind:Multiple="false"
                :Input="ChangeDropDownBuilding"
                v-bind:IsDisabled="!buildingsEnabled"
                />
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Shared.Level')"
              v-bind:Options="LevelList"
              v-bind:FieldDescription="'description'"
              v-bind:FieldCode="'code'"
              v-bind:Model="level"                       
              v-bind:Multiple="false"
              :Input="ChangeDropDownLevel"/>
          </b-col>          
          <b-col lg="3" md="3" sm="12">                  
            <MdSelect
              v-bind:Label="$tc('Shared.Room')"
              v-bind:Options="RoomList"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'" 
              v-bind:UseResetModel="true"                 
              v-bind:Model="room"                       
              v-bind:Multiple="false"
              :Input="ChangeDropDownRoom"/>
          </b-col>                  
          <b-col md="3" lg="3" sm="12">
            <div class="text-center text-md-right mt-3">
              <button v-on:click="getMedicationInboxList"
                type="button"
                class="btn btn-primary btn-login mx-2 pull-right">
                  {{ $t('Shared.Search') }}
							</button>
            </div>
					</b-col>
        </div>
      </div>
    </div>

   <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'" class="mt-2"/>

        <div class="row"> 
            <div class="col-md-3">
               <MdCheckBox
                v-bind:Label="$t('Shared.SelectAll')"
                v-bind:Name="'SelectTableAll'"
                v-bind:ClassProp="'AlignCheck mx-3'"
                v-bind:CheckedValue="true"
                v-bind:isReadOnly="this.items.length === 0"
                v-bind:UncheckedValue="false"
                v-model="UseSelectTableAll" 
                v-on:change="onChangeSelectAll"                
             /> 
            </div>
            <div class="col-md-3 mt-3">
              <span class="tableSelectedItems"><span class="selItemsVal">{{ SelectedRecords }}</span> {{ $t('claimbatchList.item') }}<span v-if="SelectedRecords != 1">s</span> {{ $t('Shared.selected') }}</span>
            </div> 
        </div> 
       
        <MdTablePaginationClient
              v-bind:refTable="'MedicationTable'"
              ref="MedicationTable"
              v-bind:fields="fields"      
              v-bind:items="items"
              v-bind:totalRows="totalRows"    
              v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
              v-bind:currentPage="currentPage"
              v-bind:perPage="perPage"
              v-bind:SelectAll="UseSelectTableAll"
              v-bind:FieldsDate="FieldsDateArr"
              v-bind:pageOptions="pageOptions" 
              v-bind:viewIconEvent="handleViewEvent"   
              v-bind:ondblClick="handleDblClick"       
              :onFiltered="onFiltered"
              :pageChanged="pageChanged"
              :RowClick="RowClicked"
              :perPageFunction="PerPageFunction"
              v-bind:hintViewIcon="'Receive'"
              v-bind:isMedicationInbox="true">
            </MdTablePaginationClient>


    <div class="space-actions"></div>
    <div class="page-actions">
          <MdButton
            v-bind:Label="$t('medicationInbox.SetToReceived')"
            v-bind:isReadOnly="items.length == 0 || !setToReceived"
            v-bind:Name="'btnReceive'"
            v-bind:ClassProp="'secondary mx-2 btn-login'"
            v-on:click="SetToReceived()"
            ref="btnReceive"/>        
    </div>
    <div class="space-actions"></div>

  </div>
</template>



<script>
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import DBFunctions from '@/common/DBFunctions.js'
  import Utils from '@/common/utils'  
  import LocalStorage from '@/services/storage.service';
  import PharmacyOptions from '@/services/pharmacyoption.service'
  import { EventBus } from '@/event-bus.js';
  import Permission from '@/common/Permission'
  import GlobalService from '@/services/global.service'
  import ClinicalService from '@/services/clinical.service'
  import PatientService from '@/services/patient.service'
  import MarsService from '@/services/mars.service'
  import AdmissionService from '@/services/admission.service'
  import MedicationService from '@/services/medication.service'
  import EnumService from '@/services/enum.service'
  import MedicationInboxService from '@/services/medicationinbox.service' 

export default {

  mixins: [ShowMessage, DBFunctions, Permission],
  name: 'MedicationInbox',

  data() {
    return {
      fields: [
          { key: 'recordID', sortable: true, label: '', class: 'hidden' },  
          { key: 'issuedDate', sortable: true, label: this.$t('Shared.StartDate'), class: 'text-rigth' },  
          //{ key: 'status', sortable: true, label: this.$t('Shared.Status'), class: 'text-rigth' },
          { key: 'patientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-rigth' },
          { key: 'patientCode', sortable: true, label: this.$t('Shared.PatientCode'), class: 'text-rigth' },
          { key: 'drugName', sortable: true, label: this.$t('Shared.DrugName'), class: 'text-rigth' },
          { key: 'activeIngredient', sortable: true, label: this.$t('Shared.activeIngredients'), class: 'text-rigth' },
          { key: 'dosage', sortable: true, label: this.$t('Shared.Dosage'), class: 'text-rigth' },
          { key: 'form', sortable: true, label: this.$t('Shared.Form'), class: 'text-rigth' },
          { key: 'quantity', sortable: true, label: this.$t('Shared.TotalQty'), class: 'text-rigth' },
          { key: 'rxStatus', sortable: true, label: this.$t('Medication.RxStatus'), class: 'text-rigth' },
          { key: 'prescriber', sortable: true, label: this.$t('Shared.Prescriber'), class: 'text-rigth' },
          { key: 'programName', sortable: true, label: this.$tc('Shared.Program'), class: 'text-rigth' },
          { key: 'buildingName', sortable: true, label: this.$t('Shared.Building'), class: 'text-rigth' },
          { key: 'levelName', sortable: true, label: this.$t('Shared.Level'), class: 'text-rigth' },
          { key: 'roomName', sortable: true, label: this.$tc('Shared.Room',1), class: 'text-rigth' },
      ],

      ShowMessageIsEmpty:false,
      pageOptions: [5, 10, 15 ],       
      items: [],
      OptionsRightMenu:{
            visible:false,
            ItemsList:[],
            btnvisible:false,
            itemdisabled: false,
            PatientCode:''         
      },
      OptionTypes:EnumService.Types,
      TypeVModel:  {value:'',name: this.$t('Shared.All')}, 
      params:{      
          NotesID: "",
          HeaderId: "", 
          PatientCode: "",
          TherapyCode: "", 
          TransDate : "",
          AdmissionRecordID: "",
          IsVoid: ""
      },
      ViewIconReadonly:false,
      UserId: LocalStorage.getUserId(),
      selectPlaceholder: this.$t('Clinical.SelectOptions'),      
      showEmptyRecords: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 0, 
      Header:{},
      parameter:{
        SearchCriteria:'',
        PageNumber : 0,
        PageSize:0,
        Status: null,
        ProgramCode: null,
        PatientCode: null,
        BuildingCode: null,
        RoomCode: null,
        LevelCode: null,
        PrescriberCode: null,
        RxStatus: 'Active',
        IsInpatient:'',      
        BuildingRestriction: this.$store.state.restrictions.buildingLocation
      },
      fullParam: {
        PageSize:0,
        PageNumber:0
      },
      DateFrom: null,
      DateTo: null,
      ProgramVmodel: null,
      Patients: null,
      buildings: null,
      room: null,
      level: null,
      ModelPrescriber: null,
      ModelRxStatus: {
        "name":"Active",
        "value":"Active"
      },
      ModelStatus: null,
      ProgramList: [],
      PatientList: [],
      BuildingList: [],
      RoomList: [],
      LevelList: [],
      PrescriberList:[],
      RxStatusList:EnumService.MedicatioInboxRxStatus,
      UseSelectTableAll:false,
      SelectedRecords:0,
      FieldsDateArr:['issuedDate'],
      //setToReceived: false,
      PharmacyOption: {},
      StatusList: [],
      selected: [],
      dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr', 
    }
  },

  computed: {
    buildingsEnabled() {
        return Utils.isNullOrEmptyString(this.$store.state.restrictions.buildingLocation);
    },
    setToReceived() {
      if (this.selected && this.selected.length > 0) {
        return this.selected.some(element => element.allowToReceive);
      }

      return false;
    }
  },

 methods: {

  async getPharmacyOptions(){
    this.$emit('load', true);             
    await PharmacyOptions.getPharmacyOptions()
      .then((response) => {
        if(response.status == '200' && response.data && response.data.length > 0){                
          this.PharmacyOption = response.data[0];
          this.$emit('load', false);   
        }
      })
      .catch((error) => {
        this.$emit('load', false);
        this.showResponseErrorMessage(error);
      });        
  },

  /*showAllActions(enabled) {
    this.setToReceived = enabled
  },*/

  onChangeSelectAll(v){
    if(v){
      this.SelectedRecords = this.items.length;
      this.selected = []
      for(var i = 0 ; i < this.items.length; i++){
        this.$set(this.items[i], 'selected', true);
        this.selected.push(this.items[i])
      }
      //this.showAllActions(true)
    }else{
      for(var j= 0 ; j < this.items.length; j++){
        this.$set(this.items[j], 'selected', false);  
      }
      this.resetSelections()
    }
  },

  RowClicked(item){
      if(item.selected){      
        this.$set(item, 'selected', false);         
      }else{
        this.$set(item, 'selected', true);       
      }
        EventBus.$emit('rowClicked', item);
    
      let itemselected = this.selected.findIndex((element) => element.recordID == item.recordID)
      
      if (itemselected != -1 && !item.selected) {
        this.selected.splice(itemselected, 1)
      } else if (itemselected == -1 && item.selected) {
        this.selected.push(item)
      }

      this.UseSelectTableAll = this.selected.length === this.items.length;

      /*if (this.selected && this.selected.length == 1 && this.selected[0].allowToReceive) {
        this.showAllActions(true)
      } else if (this.selected && this.selected.length > 1) {
        let allow = false
        this.selected.forEach(element => {
          if (element.allowToReceive) 
            allow = true
        });
        this.showAllActions(allow)
      } else {
        this.showAllActions(false)
      }*/
  },

  async handleViewEvent(item) {
    let recordID = []

    recordID.push(item.recordID.trim())
    this.setStatus(recordID)
  },

  async handleDblClick() {

  },

  resetSelections() {
      this.selected = []
      this.SelectedRecords = 0;
      this.UseSelectTableAll = false
      //this.showAllActions(false)
  },

  ChangeDropDownRxStatus(item){
    if(item !== null){
      this.ModelRxStatus = item;
      this.parameter.RxStatus = item.value;
    }else{
      this.ModelRxStatus = null
      this.parameter.RxStatus = null
    }
    this.getMedicationInboxList();
  },

  ChangeDropDownPrescriber(item){
    if(item !== null){
      this.ModelPrescriber = item;
      this.parameter.PrescriberCode = item.code;
    }else{
      this.ModelPrescriber = {code:"",name:""};
      this.parameter.PrescriberCode = null;
    }
    this.getMedicationInboxList();
  },

  ChangeDropDownStatus(item) {
    if(item !== null){
      this.ModelStatus = item;
      this.parameter.Status = item.value;
    }else{
      this.ModelStatus = null
      this.parameter.Status = null
    }
    this.getMedicationInboxList();
  },

  async getPrescribers(){
    this.$emit('load', true);              
    await MedicationService.getPrescribers()
      .then((response) => {
        if(response.status == '200' && response.data){                        
          this.PrescriberList = response.data;
        }
        this.$emit('load', false);
      })
      .catch((error) => {
        this.$emit('load', false);
        this.showResponseErrorMessage(error);
      });        
  },

  ChangeDropDownRoom(item){
    this.parameter.RoomCode = null;
    item ? this.parameter.RoomCode = item.code : this.parameter.RoomCode = null;    
    this.totalRows = 0; 
    this.getMedicationInboxList();
  },
    
  ChangeDropDownLevel(item){
    this.parameter.LevelCode = null;
    item ? this.parameter.LevelCode = item.code : this.parameter.LevelCode = null;   
    this.totalRows = 0;
    this.getMedicationInboxList();
  },

  async getBuildings(){
    this.$emit('load', true); 
    await AdmissionService.getBuildings({Code: this.$store.state.restrictions.buildingLocation})
      .then((response) => {
        if(response.status == '200'){          
          this.BuildingList = response.data;

          if (!this.buildingsEnabled) {
              this.buildings = this.$store.state.restrictions.buildingLocation;
              this.parameter.BuildingCode = this.buildings;
          }
        }
        this.$emit('load', false);                              
      })
      .catch((error) => {
        this.$emit('load', false); 
        this.showResponseErrorMessage(error);
      });
  },

  async ChangeDropDownBuilding(item){
     this.parameter.BuildingCode = null;
     item ? this.parameter.BuildingCode =item.code : this.parameter.BuildingCode = null;  
     await this.getRomms({BuildingCodeList:this.parameter.BuildingCode});
     this.parameter.RoomCode = null;
     this.room ? this.parameter.RoomCode = this.room : this.parameter.RoomCode = null;

     this.totalRows = 0;
     this.getMedicationInboxList();    
  },
  
  async getRomms(build){
    this.$emit('load', true);        
    await MarsService.getMarsRooms(build)
      .then((response) => {
        if(response.status == '200' && response.data.length > 0){                         
          this.RoomList = response.data;
          if(this.RoomList.length === 1){
            this.room = this.RoomList[0].code;
          }else{
            this.room = "";   
          }
        }                             
        this.$emit('load', false); 
      })
      .catch((error) => {
        this.$emit('load', false); 
        this.showResponseErrorMessage(error);
      }); 
  },

  async getLevel(){
    let param = {
        CodeType:"RoomLevel",
        OrderBy:"SeqNo"
    };
    this.$emit('load', true); 
    await GlobalService.getGlobalCustom(param)
      .then((response) => {
        if(response.status == '200' && response.data.length > 0){                          
          this.LevelList = response.data;
        }
        this.$emit('load', false);                              
      })
      .catch((error) => {
        this.$emit('load', false); 
        this.showResponseErrorMessage(error);
      }); 
  },

  async getPatients(){
    this.$emit('load', true);    
    await PatientService.getAll(this.fullParam)
      .then((response) => {
        if(response.status == '200' && response.data && response.data.length > 0) {               
          this.PatientList = response.data;                          
          this.PatientList.forEach(function(element) {	
            element.patientname = element.firstname + " " + element.lastname + " - "+element.patientcode;   
          });       
        }
        this.$emit('load', false);        
      })
      .catch(error => {
        this.$emit('load', false);       
        this.showResponseErrorMessage(error);
      });    
  },

  ChangeDropDownPatients(item){
      this.parameter.PatientCode = [];
      item ? this.parameter.PatientCode = item.patientcode : this.parameter.PatientCode = null
      this.totalRows = 0;  
      this.getMedicationInboxList();
  },

  SetToReceived() {
    let recordIds = []
    if (this.selected && this.selected.length > 0) {
      this.selected.forEach(element => {
        recordIds.push(element.recordID.trim())
      });
      this.setStatus(recordIds)
      this.resetSelections()
    }
    this.resetSelections()
  },

  async getPrograms(){
      this.$emit('load', true); 
      const parameter = {
          programsRestriction:  this.$store.state.restrictions.programs
      }
      await ClinicalService.getPrograms(parameter)
        .then((response) => {
          if(response.status == '200' && response.data && response.data.length > 0){                        
            this.ProgramList = response.data;                                          
          }               
          this.$emit('load', false); 
        })
        .catch((error) => {
          this.$emit('load', false); 
          this.showResponseErrorMessage(error);
        });  
  },

  async ChangeDropDownPrograms(item){ 
      this.parameter.ProgramCode = [];      
      item ? this.parameter.ProgramCode =item.code : this.parameter.ProgramCode = null;  
      this.totalRows = 0;
      this.getMedicationInboxList();
  },

  ChangeDropDownType(item) {
      this.parameter.IsInpatient = null;
      item ? this.parameter.IsInpatient =item.value : this.parameter.IsInpatient = null;  
      this.totalRows = 0;
      this.getMedicationInboxList();
  },  
  
  onRowSelected(){

  },

  PerPageFunction(value){
      this.perPage = value;
      this.currentPage = 1;
      this.getMedicationInboxList();
  },

  pageChanged(){

  },

  onFiltered(filteredItems){
    this.totalRows = filteredItems.length;
    this.currentPage = 1;
  },
  
  DateFromChange() {

  },

  DateToChange() {

  },

  perPageChange(value) {
    this.perPage = value;
    this.getMedicationInboxList();
  },
    
  onChange(page) {
    this.currentPage = page;
    this.getMedicationInboxList();
  },

  async setStatus(recordIds) {
    let param = {
      "recordIds": recordIds
    }
    await MedicationInboxService.SetStatus(param)
      .then((response) => {             
        if(response.status == '200'){           
          if (response.data.affectedRows === recordIds.length) {            
            this.$bvToast.toast(this.$t('medicationInbox.SetToReceivedMsg'), {
              title: this.$t('Msg.Success'),
              autoHideDelay: 5000,
              variant: "success"
            });
          } else {
            this.$bvToast.toast(
                response.data.affectedRows +" "
                +this.$t('MdGenericOutCome.OutOf')+" "
                +recordIds.length+" "
                +this.$t('medicationInbox.ItemsAffected'), 
              {
                title:this.$tc('Msg.Warning', 1),
                autoHideDelay: 5000,
                variant: "warning"
              }
            );
          }
          this.Load = false;
          this.getMedicationInboxList();
        }
       })
       .catch((error) => {       
          this.Load = false;
          if (!error.response) {
            this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.NotAbleToInsert'),"error");
          }                      
          else if(error.response.status === 400 ){
            this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
          } else if(error.response.status === 500){
            this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
          } else{
            this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
          }           
       });
    },
    
    async getMedicationInboxList() {     
      this.parameter.DateFrom = this.DateFrom
      this.parameter.DateTo = this.DateTo
      this.parameter.IsInPatient = this.TypeVModel.value;
      
      const parameters = {
        ...this.parameter
      }
      if (Utils.isNullOrEmptyString(this.parameter.ProgramCode)) {
          parameters.ProgramsRestriction = [...this.$store.state.restrictions.programs];
      }

      await MedicationInboxService.getAll(parameters)
        .then((response) => {
          if (response.status == "200" && response.data) {           
            this.items = response.data;
            let headerString = response.headers["x-pagination"];
            this.Header = JSON.parse(headerString);
            this.totalRows = this.Header.TotalCount;
            this.showEmptyRecords = response.data && response.data.length == 0 ? true : false;
            this.ShowMessageIsEmpty = response.data && response.data.length == 0 ? true : false;
            
            this.items.forEach(function (element) {              
              if (element.issuedDate)                
                element.issuedDate = element.issuedDate ? Utils.formatterDateToString(element.issuedDate) : null;                             
            });
            
            this.SelectedRecords = 0;
            this.UseSelectTableAll = false; 
           
          }
          
        })
        .catch((error) => {        
          if (!error.response) {
            // network error
            this.showMessage(
              this.$tc('Msg.Error'),
              this.$t('Msg.retrieveInfo'),
              "error"
            );
          } else {
            this.showMessage(this.$tc('Msg.Error'), error, "error");
          }
        });
    },

    async getDateTime() {           
      this.$emit('load', true); 
      await GlobalService.getDateTime()
        .then((response) => {      
          if (response.data) {
            this.DateFrom = Utils.formatterDate(response.data); 
            this.DateTo = Utils.formatterDate(response.data); 
          }                   
          this.$emit('load', false); 
        })
        .catch(error => {
          this.$emit('load', false); 
          if (error.response) {
            this.showMessage(this.$tc('Msg.Error'),error,"error");
          }                   
        }); 
    },

    getStatus() {
      if (this.PharmacyOption.byPassInventory)
        this.StatusList = EnumService.MedicationInboxSatusBPIList
      else
        this.StatusList = EnumService.MedicationInboxSatusList
    }
  },

  async created(){
    EventBus.$on("rowClicked", function () {        
      this.SelectedRecords = 0;
      for(var i = 0; i < this.items.length; i++){
        if(this.items[i].selected){
          this.SelectedRecords++;
        }
      }  
    }.bind(this));
  },

  async mounted() {
    this.OptionsRightMenu.ItemsList = []
    let layoutStatus = this.$store.state.layoutStatus;
    switch(layoutStatus) {
      case 'L0R1':
        this.OptionsRightMenu.favButtonAtion = true;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
      case 'L1R0':
      case 'L1R1':
        this.OptionsRightMenu.btnvisible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
      default:
        this.OptionsRightMenu.favButtonAtion = true;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    }

    await this.getPharmacyOptions()
    this.getStatus()
    await this.getDateTime();
    await this.getPrograms()
    await this.getPatients()
    await this.getBuildings()
    await this.getLevel()
    await this.getRomms({BuildingCodeList:[]}),
    await this.getPrescribers()
    this.getMedicationInboxList();
  },

  destroyed(){
  }
};

</script>